define('lib/Podio.UI.Subscriptions',['require','translate','jquery','lib/Podio.Router','lib/Podio.Routes','lib/Podio.Transport','lib/Podio.UI.Modal','lib/Podio.UI.FlashMessage','lib/backbone/Backbone.Mixins.Transport.API','views/subscriptions/Podio.Views.SubscriptionsList','views/subscriptions/Podio.Views.SubscriptionsSettings','lib/Podio.Event.UI'],function (require) {

  var t = require('translate');
  var $ = require('jquery');
  var router = require('lib/Podio.Router');
  var routes = require('lib/Podio.Routes');
  var transport = require('lib/Podio.Transport');
  var modal = require('lib/Podio.UI.Modal');
  var flashMessage = require('lib/Podio.UI.FlashMessage');
  var APITransport = require('lib/backbone/Backbone.Mixins.Transport.API');
  var SubscriptionsView = require('views/subscriptions/Podio.Views.SubscriptionsList');
  var SubscriptionsSettingsView = require('views/subscriptions/Podio.Views.SubscriptionsSettings');
  var eventUI = require('lib/Podio.Event.UI');

  var unfollowList = [];
  var groupSettings = {};
  var listView;
  var settingsView;

  function show() {
    modal.showLoading();

    if (listView) {
      listView.dispose();
      listView = null;
    }

    APITransport.request('get', '/subscription/inactive', {fields: 'apps.fields(space.view(micro).fields(org.view(micro))),spaces.fields(org.view(micro))'}).done(function(result) {

      listView = new SubscriptionsView({
        apps: result.apps,
        spaces: result.spaces
      });
      listView.render();

      modal.show(listView.elm, {
        title: t('Manage your notifications #unroll'),
        className: 'subscriptions-modal',
        footerHtml: '<div class="buttons"><a href="#" class="button-new cancel-button secondary" color="secondary">{0}</a><a href="#" class="button-new next-button primary" color="primary">{1}</a></div>'.format(t('Cancel #unroll'), t('Next #unroll')),
        hideHandler: modalHideHandler
      });

    });

  }

  function modalHideHandler() {
    router.goToHashRoute('');
    return true;
  }

  function onCancelClicked(elmTarget, e) {
    modal.hide();
  }

  function onNextClicked(elmTarget, e) {
    unfollowList = [];
    $('.subscriptions-modal input[type=checkbox]:checked').each(function(index, elmBox) {
      unfollowList.push({ref_type: $(elmBox).data('ref-type'), ref_id: $(elmBox).data('ref-id')});
    });

    modal.showLoading();
    APITransport.request('get', '/email/group', {}).done(function(groups) {
      groupSettings = groups;

      var count = $('.navigation-link.inbox').data('count');
      settingsView = new SubscriptionsSettingsView({
        groups: groupSettings,
        inboxCount: count ? count : '0'
      });
      settingsView.render();

      modal.show(settingsView.elm, {
        title: t('Manage your notifications #unroll'),
        className: 'subscriptions-modal',
        footerHtml: '<div class="buttons"><a href="#" class="button-new cancel-button secondary" color="secondary">{0}</a><a href="#" class="button-new done-button priamry" color="primary">{1}</a></div>'.format(t('Cancel #unroll'), t('Done #unroll')),
        hideHandler: modalHideHandler
      });

    });

  }

  function onAnyChanged(elmTarget, e) {
    $('.subscriptions-modal .subscriptions-groups input').prop('checked', elmTarget.is(':checked'));
  }

  function onGroupChanged(elmTarget, e) {
    var elmInputs = $('.subscriptions-modal .subscriptions-groups input');
    $('.subscriptions-modal input[name=any]').prop('checked', elmInputs.filter(':checked').length == elmInputs.length);
  }

  function onDoneClicked(elmTarget, e) {
    var markAsRead = $('.subscriptions-modal input[name=read]').is(':checked');

    $('.subscriptions-modal .subscriptions-groups input').each(function(index, elmInput) {
      groupSettings[$(elmInput).attr('name')] = $(elmInput).is(':checked');
    });

    modal.showLoading();

    transport.putJSON(routes.email_subscriptions_update_path(), {requestData: {
      unfollow: unfollowList,
      groups: groupSettings,
      mark_as_read: markAsRead
    }}, function(responseData) {
      modal.hide();
      router.goToHashRoute('');
      flashMessage.show(t('Your subscriptions and notification settings have been updated. #unfollow'));
    });


  }

  function onItemClicked(elmTarget, e) {
    if ($(e.target).is('input') || $(e.target).is('label')) {
      return;
    }
    var elmCheckbox = elmTarget.find('input[type=checkbox]');
    elmCheckbox.prop('checked', !elmCheckbox.is(':checked'));
  }

  function onShowRouteInvoked() {
    return show();
  }

  router.addHashRoute('subscriptions', onShowRouteInvoked);
  eventUI.bind('change', '.subscriptions-modal input[name=any]', onAnyChanged);
  eventUI.bind('change', '.subscriptions-modal .subscriptions-groups input', onGroupChanged);
  eventUI.bind('click', '.subscriptions-modal .cancel-button', onCancelClicked);
  eventUI.bind('click', '.subscriptions-modal .next-button', onNextClicked);
  eventUI.bind('click', '.subscriptions-modal .done-button', onDoneClicked);
  eventUI.bind('click', '.subscriptions-modal .subscriptions-list > li', onItemClicked, true);

  return {
    show: show
  };

});

